import React, { useRef } from 'react';
import {
  Box,
  DialogContent,
  Button,
  DialogActions,
} from '@mui/material';
import BootstrapDialog, {
  BootstrapDialogTitle,
} from '../../common/dialog/BootstrapDialog';
import EstimatePreview from './EstimatePreview';
import { useSelector } from 'react-redux';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { createDraggablePaperComponent } from '../../common/dialog/DraggablePaper';

const PaperComponent = createDraggablePaperComponent('draggable-preview-dialog');

const EstimatePreviewModal = ({
  type,
  open,
  handleClose,
  estimate,
  project,
}) => {
  const previewRef = useRef();
  const { costs, productCosts } = useSelector(({ projectModule }) => ({
    costs: projectModule.projectCosts.costs,
    productCosts: projectModule.projectEstimateCosts.costs,
  }));

  const exportPDF = () => {
    const el = previewRef.current;
    html2canvas(el, { scale: '2' }).then((canvas) => {
      //document.body.appendChild(canvas);  // if you want see your screenshot in body.
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210; // 이미지 가로 길이(mm) A4 기준
      const pageHeight = imgWidth * 1.414; // 출력 페이지 세로 길이 계산 A4 기준
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      const pdf = new jsPDF('p', 'mm', 'a4');
      let position = 0;

      // 첫 페이지 출력
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      // 한 페이지 이상일 경우 루프 돌면서 출력
      while (heightLeft >= 20) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      }

      pdf.save(project?.cstNm + '견적서.pdf');
    });
  };

  return (
    <BootstrapDialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-preview-dialog"
      fullWidth={true}
      maxWidth="lg"
    >
      <BootstrapDialogTitle
        style={{ cursor: 'move' }}
        id="draggable-preview-dialog"
        onClose={handleClose}
      >
        견적서 미리보기
      </BootstrapDialogTitle>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <DialogContent
          dividers
          sx={{
            height: 600,
            overflowY: 'auto',
          }}
        >
          <EstimatePreview
            previewRef={previewRef}
            estimate={estimate}
            project={project}
            productCosts={costs}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="warning" onClick={exportPDF}>
            PDF 다운로드
          </Button>
        </DialogActions>
      </Box>
    </BootstrapDialog>
  );
};

export default EstimatePreviewModal;
